export default __webpack_public_path__ + "img/clov.06ad577b.jpg";